import { registerOverlay } from './registry';
import { attackedPiecesPlugin } from './plugins/attackedPieces';

let registered = false;

/** Idempotent: call once at app boot. Board shows overlays only after quiz Show. */
export function registerAwarenessOverlays(): void {
  if (registered) return;
  registerOverlay(attackedPiecesPlugin);
  registered = true;
}
